import React, { useContext } from "react";
import { DeviceControlsContextState } from "./interfaces";

export const DeviceControlsContext = React.createContext<DeviceControlsContextState | undefined>(undefined);

export function useDeviceControlsContext(options?: { raiseIfUndefined?: true }): DeviceControlsContextState;
export function useDeviceControlsContext(options: { raiseIfUndefined: false }): DeviceControlsContextState | undefined;
export function useDeviceControlsContext(options: { raiseIfUndefined?: boolean } = {}): DeviceControlsContextState | undefined {
  const { raiseIfUndefined = true } = options;
  const context = useContext(DeviceControlsContext);
  if (!context && raiseIfUndefined) {
    throw new Error("useDeviceControlsContext must be used within a DeviceControlsProvider");
  }
  return context;
}
